import { AUTOMATIONS_PAGE_LINK, CRM_SALES_PAGE_LINK, DASHBOARDS_PAGE_LINK, DEPARTMENTS_HR_LINK, DEPARTMENTS_IT_LINK, DEPARTMENTS_LEGAL_LINK, DEPARTMENTS_MARKETING_LINK, DEPARTMENTS_PMO_LINK, FORMS_PAGE_LINK, INTEGRATIONS_PAGE_LINK, MCP_PAGE_LINK, MONDAY_AGENTS_HEADER_LINK, MONDAY_AI_WORKFLOWS_HEADER_LINK, MONDAY_DB_PAGE_LINK, MONDAY_NOTETAKER_HEADER_LINK, MONDAY_SIDEKICK_HEADER_LINK, MONDAY_VIBE_HEADER_LINK, USE_CASES_LINK, OPERATIONS_CLUSTER_LINK, SERVICE_MINI_SITE_LINK, SOFTWARE_MINI_SITE_LINK, WORKDOCS_PAGE_LINK } from "constants/links";
import { AutomationsIcon, InfrastructureIcon, IntegrationsIcon, MCPIcon } from "../products-menu-component/icons/index.js";
import { SidekickIcon, NotetakerIcon, AIWorkflowsIcon, VibeIcon, AgentsIcon, DocsIcon, FormsIcon, DashboardsIcon } from "./icons/index.js";
const avatarUrl = (filename)=>`https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/${filename}`;
const AI_PLATFORM_AVATAR_IMAGE_URLS = {
    pmo: avatarUrl("Menu2026-AIPlatfromMulti-product-pmo-N6vmE.png"),
    marketing: avatarUrl("Menu2026-AIPlatfromMulti-product-marketing-AXkY4.png"),
    sales: avatarUrl("Menu2026-AIPlatfromMulti-product-sales-htyHG.png"),
    operations: avatarUrl("Menu2026-AIPlatfromMulti-product-operations-zuIDm.png"),
    it: avatarUrl("Menu2026-AIPlatfromMulti-product-it-Ir59m.png"),
    product: avatarUrl("Menu2026-AIPlatfromMulti-product-product-5oMSO.png"),
    hr: avatarUrl("Menu2026-AIPlatfromMulti-product-hr-bjqrP.png"),
    rnd: avatarUrl("Menu2026-AIPlatfromMulti-product-legal-N7V5M.png"),
    legal: avatarUrl("Menu2026-AIPlatfromMulti-product-legal.png")
};
export const AI_PLATFORM_USE_CASE_LINKS = [
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.pmo,
        titleKey: "header.tabs.solution.pmo",
        descriptionKey: "header.tabs.aiPlatform.useCase.pmo.description",
        link: DEPARTMENTS_PMO_LINK
    },
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.it,
        titleKey: "header.tabs.solution.it",
        descriptionKey: "header.tabs.aiPlatform.useCase.it.description",
        link: DEPARTMENTS_IT_LINK
    },
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.marketing,
        titleKey: "header.tabs.solution.marketing",
        descriptionKey: "header.tabs.aiPlatform.useCase.marketing.description",
        link: DEPARTMENTS_MARKETING_LINK
    },
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.hr,
        titleKey: "header.tabs.solution.hr",
        descriptionKey: "header.tabs.aiPlatform.useCase.hr.description",
        link: DEPARTMENTS_HR_LINK
    },
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.operations,
        titleKey: "header.tabs.solution.operations",
        descriptionKey: "header.tabs.aiPlatform.useCase.operations.description",
        link: OPERATIONS_CLUSTER_LINK
    },
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.sales,
        titleKey: "header.tabs.solution.sales",
        descriptionKey: "header.tabs.aiPlatform.useCase.sales.description",
        link: CRM_SALES_PAGE_LINK
    },
    {
        iconUrl: AI_PLATFORM_AVATAR_IMAGE_URLS.legal,
        titleKey: "header.tabs.solution.legal",
        descriptionKey: "header.tabs.aiPlatform.useCase.legal.description",
        link: DEPARTMENTS_LEGAL_LINK
    }
];
export const AI_PLATFORM_CAPABILITY_GROUPS = [
    {
        column: 1,
        headingKey: "header.tabs.aiPlatform.capabilities.group.agents",
        links: [
            {
                Icon: AgentsIcon,
                textKey: "header.tabs.aiPlatform.capabilities.agentBuilder",
                link: MONDAY_AGENTS_HEADER_LINK
            },
            {
                Icon: SidekickIcon,
                textKey: "header.tabs.aiPlatform.capabilities.aiAssistant",
                link: MONDAY_SIDEKICK_HEADER_LINK
            },
            {
                Icon: NotetakerIcon,
                textKey: "header.tabs.aiPlatform.capabilities.notetaker",
                link: MONDAY_NOTETAKER_HEADER_LINK
            },
            {
                Icon: AIWorkflowsIcon,
                textKey: "header.tabs.aiPlatform.capabilities.aiWorkflows",
                link: MONDAY_AI_WORKFLOWS_HEADER_LINK
            }
        ]
    },
    {
        column: 2,
        headingKey: "header.tabs.aiPlatform.capabilities.group.workSurface",
        links: [
            {
                Icon: VibeIcon,
                textKey: "header.tabs.aiPlatform.capabilities.vibeCoding",
                link: MONDAY_VIBE_HEADER_LINK
            },
            {
                Icon: DashboardsIcon,
                textKey: "header.tabs.aiPlatform.capabilities.dashboards",
                link: DASHBOARDS_PAGE_LINK
            },
            {
                Icon: DocsIcon,
                textKey: "header.tabs.features.keyFeatures.docs.title",
                link: WORKDOCS_PAGE_LINK
            },
            {
                Icon: FormsIcon,
                textKey: "header.tabs.features.keyFeatures.forms.title",
                link: FORMS_PAGE_LINK
            }
        ]
    },
    {
        column: 3,
        headingKey: "header.tabs.aiPlatform.capabilities.group.anyTool",
        links: [
            {
                Icon: IntegrationsIcon,
                textKey: "header.tabs.products.integrations",
                link: INTEGRATIONS_PAGE_LINK
            },
            {
                Icon: AutomationsIcon,
                textKey: "header.tabs.products.automations",
                link: AUTOMATIONS_PAGE_LINK
            },
            {
                Icon: InfrastructureIcon,
                textKey: "header.tabs.aiPlatform.capabilities.infra",
                link: MONDAY_DB_PAGE_LINK
            },
            {
                Icon: MCPIcon,
                textKey: "header.tabs.aiPlatform.capabilities.mcp",
                link: MCP_PAGE_LINK
            }
        ]
    }
];
export const AI_PLATFORM_CREATE_SOLUTION = {
    textKey: "header.tabs.aiPlatform.viewAllUseCases",
    link: USE_CASES_LINK
};
// Locales whose translated use-case labels wrap to 2 lines at the default menu width, needing a wider layout.
export const WIDE_AI_MENU_LOCALE_IDS = [
    "es"
];
